import { lazy } from 'react';

const CharityVettingHACCPCertificateRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingHACCPCertificate" */ '../components/steps/HACCP-certificate-step/HACCPCertificate'
    ),
);

export default CharityVettingHACCPCertificateRoute;
